<div class="map-wrapper">
  <google-map #map [options]="this.options" [width]="'100%'" [height]="'100%'">
    @for (marker of this.markers(); track marker.position) {
      <map-advanced-marker
        #mapMarker="mapAdvancedMarker"
        [position]="marker.position"
        [title]="marker.title"
        (mapClick)="this.openInfoWindow(mapMarker)"
      ></map-advanced-marker>
    }

    <map-info-window>
      {{ this.selectedMarkerTitle() }}
    </map-info-window>
  </google-map>

  <div class="map-type-toggle">
    <cam-button type="secondary" size="small" (action)="this.toggleMapType()">
      <cam-font-icon [name]="this.isSatellite() ? 'pin' : 'image'" type="xs"></cam-font-icon>
      <cam-text size="sm">{{ this.isSatellite() ? 'Plan' : 'Satellite' }}</cam-text>
    </cam-button>
  </div>
</div>
